import { Outlet } from "react-router-dom";
import Login from "../../Auth/Login";
import { useDispatch, useSelector } from "react-redux";
import StudentNav from "./StudentNav";
import Breadcrumb from "../../Props/Breadcrumb";
import DashMobileNav from "../../components/DashMobileNav";

const STUDENT_NAV_ITEMS = [
    { to: '/home/student', icon: 'fa-light fa-grid-2', label: 'Dashboard', end: true },
    { to: '/home/chat', icon: 'fa-light fa-message-lines', label: 'Messages', badge: 'unread' },
    { to: '/home/my-lessons', icon: 'fa-light fa-chalkboard-user', label: 'My Lessons' },
    { to: '/home/save-course', icon: 'fa-light fa-heart', label: 'Saved Courses' },
    { to: '/home/transactions', icon: 'fa-light fa-list', label: 'Transactions' },
    { to: '/home/settings/profile', icon: 'fa-light fa-user-gear', label: 'Settings' },
];

export default function StudentDashboard(){
    const dispatch = useDispatch();
    const { user, accessToken } = useSelector((state) => state.authReducer);
  if (!accessToken) {
    return (
      <>
        <Login />
      </>
    );
  }
    return (
        <div className="dash-shell">
         <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
            <Breadcrumb title={`Student Dashboard`} sub_title={`Dashboard`}/>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content student-panel">
        <div className="container">
          <DashMobileNav items={STUDENT_NAV_ITEMS} />
          <div className="row">
            <div className="col-xl-3 col-lg-3 panelSidebar">
              <StudentNav />
            </div>
            <div className="col-lg-9 col-xl-9 col-12">
             
            <Outlet/>

            </div>
          </div>
        </div>
      </div>
        </div>
    )
}